<template>
    <div>
    
      <div style="margin-top:56px;" >
            <div class="container" style="margin-top:0px">
                <div class="row  lang-header">
                    <div class="col-md-5" style="text-align: center;">
                      <img src="https://tsyyapi.dctechonline.cn/static/images/p1.jpg" class="home-img" style="opacity:0.8;width:90%;margin-bottom:5px;"/>
                    </div>
                    <div class="col-md-7">
                        <p style="padding-top:20px">AP CSA（AP Computer Science A）考试是由美国大学理事会（College Board）主办的大学先修课程考试，主要考察学生的 Java 编程能力和计算机科学基础知识。</p>
                        <p>通过 AP CSA 考试并取得高分，不仅可以展示你的编程能力，还可能获得大学学分，为未来的学术和职业发展打下坚实基础。</p>
    
                        <div style="text-align: center;margin-top:20px;"><button class="btn btn-primary" style="background:#04b2c5;border-color:#04b2c5;margin:0px 10px"
                            id="drawerToggle" >查看AP CSA考试介绍</button>
                            </div>
                    </div>
                 
                
                </div>
    
                
            </div>
        </div>
        <div class="container" style="margin-top:50px">
       
          <div class="row" style="margin-top: 60px;">
            <div class="col-md-6" style="margin-bottom:20px">
              <h4 class="text-center mb-4">Java编程基础（18 * 1 hour) </h4>
              <!-- <button class="btn btn-danger" style="margin:0px 10px 20px 10px"
                          @click="goBuy()">课程购买</button> -->
              <ul class="list-group">
                <li class="list-group-item">第1节课：Java 编程Overview</li>
                <li class="list-group-item">第2节课：变量和数据类型</li>
                <li class="list-group-item">第3节课：条件语句</li>
                <li class="list-group-item">第4节课：循环语句1</li>
                <li class="list-group-item">第5节课：循环语句2</li>
                <li class="list-group-item">第6节课：数组的概念和运用</li>
                <li class="list-group-item">第7节课：二维数组的概念和运用</li>
                <li class="list-group-item">第8节课：函数的概念和运用</li>
                <li class="list-group-item">第9节课：字符串String与数学相关类Math</li>
                <li class="list-group-item">第10节课：递归函数</li>
                <li class="list-group-item">第11节课：可变列表ArrayList</li>
                <li class="list-group-item">第12节课：集合与哈希表</li>
                <li class="list-group-item">第13节课：面向对象1: 类和对象</li>
                <li class="list-group-item">第14节课：面向对象2: 继承和多态</li>
                <li class="list-group-item">第15节课：面向对象3: 综合运用</li>
                <li class="list-group-item">第16节课：查找算法</li>
                <li class="list-group-item">第17节课：排序算法1</li>
                <li class="list-group-item">第18节课：排序算法2</li>
              </ul>

            </div>
            <div class="col-md-6" style="margin-bottom:20px">
              <h4 class="text-center mb-4">AP考试专项训练（10 * 1h）</h4>
              <!-- <button class="btn btn-danger" style="margin:0px 10px 20px 10px"
                          @click="goBuy()">课程购买</button> -->
              <ul class="list-group">
                <li class="list-group-item">第1节课：综合复习1: 语法基础</li>
                <li class="list-group-item">第2节课：综合复习2: 面向对象</li>
                <li class="list-group-item">第3节课：综合复习3: 基本算法</li>
                <li class="list-group-item">第4节课：综合复习4: 常用类的使用</li>
                <li class="list-group-item">第5节课：选择题考点分布1</li>
                <li class="list-group-item">第6节课：选择题考点分布2</li>
                <li class="list-group-item">第7节课：选择题考点分布3</li>
                <li class="list-group-item">第8节课：编程题考点分布1</li>
                <li class="list-group-item">第9节课：编程题考点分布2</li>
                <li class="list-group-item">第10节课：编程题考点分布3</li>
              </ul>
            </div>
          </div>
    
          <div class="row mt-5">
            
            <div class="col-md-7">
              <h3 style="margin:20px 0px">教学师资</h3>
                <p style="text-align: left;">团队教师都是来自于985高校计算机专业毕业的在线编程老师，为孩子提供专业指导和支持，有丰富的教学经验。</p>
                <p style="text-align: left;">首席讲师硕士毕业于上海交通大学，在IT互联网行业深耕多年。</p>
            </div>
    
            <div class="col-md-5">
              <img src="/images/teach.jpg" class="img-fluid" alt="Processing编程教室">
            </div>
          </div>
    
          <hr/>
    
          <div class="row" style="margin-top:50px;margin-bottom:50px;">
            <div class="col-md-7">
                <img src="/images/back2.jpg" class="img-fluid" alt="Processing编程教室"></img>
    
            </div>
            <div class="col-md-5">
                <h3 style="margin:20px 0px">我要上课</h3>
                
                <div style="margin-bottom:20px">联系课程顾问获取课程价格以及上课方式</div>
                <div><img src="https://tsyyapi.dctechonline.cn/static/images/head.jpg" style="max-width:180px"/></div>
            </div>
          </div>
          
        </div>

       
        
        <div id="drawer" class="drawer">
        <div class="drawer-content">
            <h4>AP CSA 考试介绍</h4>
     
    <p>AP CSA（AP Computer Science A）考试是由美国大学理事会（College Board）主办的大学先修课程考试，主要考察学生的 Java 编程能力和计算机科学基础知识。以下是考试的基本介绍：</p>

    <div class="section">
        <h5>1. 考试内容</h5>
        <p>AP CSA 考试主要涵盖以下内容：</p>
        <ul>
            <li><strong>编程基础</strong>：变量、数据类型、运算符、控制结构（如循环和条件语句）。</li>
            <li><strong>面向对象编程</strong>：类、对象、继承、多态、接口等。</li>
            <li><strong>数组和数组列表</strong>：一维和二维数组的使用，以及 ArrayList 的操作。</li>
            <li><strong>递归</strong>：递归算法的设计与实现。</li>
            <li><strong>算法和问题解决</strong>：常见算法（如排序和搜索）的实现与分析。</li>
            <li><strong>标准类库</strong>：Java 标准类库的使用，如 <code>Math</code>、<code>String</code> 等。</li>
        </ul>
    </div>

    <div class="section">
        <h5>2. 考试形式</h5>
        <p>AP CSA 考试分为两部分，总时长 3 小时：</p>
        <ul>
            <li><strong>第一部分：多项选择题（Multiple Choice）</strong>
                <ul>
                    <li>题量：40 道题</li>
                    <li>时长：90 分钟</li>
                    <li>分值：占总分的 50%</li>
                    <li>内容：考察学生对 Java 语法、算法和程序逻辑的理解。</li>
                </ul>
            </li>
            <li><strong>第二部分：自由回答题（Free Response）</strong>
                <ul>
                    <li>题量：4 道题</li>
                    <li>时长：90 分钟</li>
                    <li>分值：占总分的 50%</li>
                    <li>内容：要求学生编写代码，解决具体问题，考察编程能力和问题解决能力。</li>
                </ul>
            </li>
        </ul>
    </div>

    <div class="section">
        <h5>3. 评分标准</h5>
        <ul>
            <li>考试总分为 1-5 分，5 分为最高分。</li>
            <li>多项选择题和自由回答题各占 50% 的分数。</li>
            <li>自由回答题的评分标准包括代码的正确性、效率和逻辑清晰度。</li>
        </ul>
    </div>

    <div class="section">
        <h5>4. 备考建议</h5>
        <ul>
            <li><strong>掌握 Java 语法</strong>：熟悉 Java 的基本语法和常用类库。</li>
            <li><strong>练习编程</strong>：通过编写代码解决实际问题，提升编程能力。</li>
            <li><strong>做真题</strong>：练习历年真题，熟悉考试题型和难度。</li>
            <li><strong>理解概念</strong>：深入理解面向对象编程、递归和算法设计等核心概念。</li>
        </ul>
    </div>

   

    <div class="section">
        <h5>5. 考试日期</h5>
        <p>AP CSA 考试通常在每年 5 月举行，具体日期由 College Board 公布。</p>
    </div>

    <div class="section">
        <h5>6. 适用对象</h5>
        <p>AP CSA 适合对计算机科学感兴趣的高中生，尤其是计划在大学学习计算机科学、工程或相关专业的学生。</p>
    </div>

        </div>
    </div>
    <div v-html="html"></div>
    <!-- 遮罩层 -->
    <div id="overlay" class="overlay"></div>
        <bottom></bottom>
    </div>
 
      </template>
      
      <script>
      import bottom from '../components/bottom.vue';
      export default {
        name: 'ProcessingCourse',
        components:{
            bottom
        },
        data(){
            return{
                html:"",
            }
        },
        methods:{
          toClass(){
            this.$router.push('class');
          },
          goBuy(){
            this.$http.get('https://aiapi.dctechonline.cn/api/pay/dctech').then(res=>{
                this.html = res.data;
                setTimeout( ()=>{
                    $("form").submit();
                },200);

                
            })
          }
        },
        mounted(){
            $('#element').toast('show')

            $('#drawerToggle').click(function() {
                $('#drawer').toggleClass('open');
                $('#overlay').toggleClass('open');
            });

            $('#overlay').click(function() {
                $('#drawer').removeClass('open');
                $('#overlay').removeClass('open');
            });
        }
      }
      </script>
      
      <style>
      h1 {
        font-size: 48px;
        font-weight: bold;
      }
      
      h3 {
        font-size: 32px;
        font-weight: bold;
      }
      
      p {
        font-size: 18px;
      }
      
      .list-group-item {
        font-size: 16px;
        font-weight: bold;
      }
      
      .img-fluid {
        max-width: 100%;
        height: auto;
      }
    
      @media (max-width:800px) {
        .list-group-item {
            font-size: 18px;
            font-weight: bold;
        }
    
        h3{
            font-size:24px;
        }
      }


      .drawer {
            position: fixed;
            top: 0;
            left: -400px;
            width: 400px;
            max-width: 100%;
            height: 100%;
            background-color: #f8f9fa;
            transition: left 0.3s ease-in-out;
            z-index: 1000;
            overflow: auto;
        }

        .drawer.open {
            left: 0;
        }

        .drawer-content {
            padding: 20px;
            font-size:14px;
        }

        .drawer p{
            font-size: 14px;
        }

        .overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 999;
            display: none;
        }

        .overlay.open {
            display: block;
        }
      </style>